<template>
  <div class="tools-partners-invites-sent">
    <button
      class="btn btn-primary btn-primary btn-block btn-sm btn-40 d-lg-none mb-6"
      @click="dialog = true"
    >
      <i class="fa-solid fa-plus mr-6" />
      Adicionar colaborador
    </button>

    <div class="row justify-content-between">
      <div class="d-flex align-items-center col-lg-6">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count }}
        </span>
        <button class="btn p-0 table-refresh" @click="dispatch">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>

      <div class="d-none d-lg-flex ml-3">
        <button
          class="btn btn-primary btn-primary px-5 btn-sm btn-40"
          @click="dialog = true"
        >
          <i class="fa-solid fa-plus mr-6" />
          Adicionar colaborador
        </button>
      </div>
    </div>

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!pagination.count"
      class="container centralize-row text-center pt-5"
    >
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <img
            class="d-block mb-9 mx-auto"
            src="@/assets/images/home/welcome.svg"
          />
          <h5>Você ainda não enviou convites</h5>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- desktop area -->
      <data-table
        new-design
        class="d-none d-lg-block"
        columnsFr="1fr 1fr 1fr 0.4fr"
        :columns="columns"
        :data="invitesSent"
      >
        <template #default="{ item }">
          <span>
            {{ item.name }}
          </span>
          <span>
            {{ item.email }}
          </span>
          <span>
            {{ profile(item) }}
          </span>
          <div>
            <span :class="statusBadge(item)">
              {{
                item.accepted_at
                  ? "Aprovado"
                  : item.rejected_at
                  ? "Rejeitado"
                  : "Pendente"
              }}
            </span>
          </div>
        </template>
      </data-table>
      <!-- end of desktop -->
      <!-- mobile area -->
      <data-table
        new-design
        class="d-lg-none"
        :columns="['', '']"
        :data="invitesSent"
      >
        <template #default="{ item }">
          <div class="d-flex flex-column py-5 responsive-table">
            <small>
              <strong>Usuário: </strong>
              {{ item.name }}
            </small>
            <small>
              <strong>Email: </strong>
              {{ item.email }}
            </small>
            <small>
              <strong>Perfil: </strong>
              {{ profile(item) }}
            </small>
            <small>
              <strong>Status: </strong>
              <small>
                {{
                  item.accepted_at
                    ? "Aprovado"
                    : item.rejected_at
                    ? "Rejeitado"
                    : "Pendente"
                }}
              </small>
            </small>
          </div>
        </template>
      </data-table>
      <!-- end of mobile -->
    </div>

    <div class="mt-5 d-flex justify-content-end">
      <paginator
        v-show="invitesSent.length && !loading"
        :pagination="pagination"
        @on-update="dispatch"
      />
    </div>

    <responsive-modal v-model="dialog" size="lg">
      <invite-modal
        v-if="dialog"
        :item="itemToEdit"
        @reload="dispatch"
        @close="dialog = false"
      />
    </responsive-modal>
  </div>
</template>

<script>
import { get } from "lodash";
import { mapState } from "vuex";
import InviteModal from "./InviteModal";

export default {
  components: { InviteModal },
  data() {
    return {
      dialog: false,
      loading: false,
      itemToEdit: null,
      actions: [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit"
        }
      ],
      columns: ["Usuário", "E-mail", "Perfil", "Status", ""],
      pagination: { count: 0 }
    };
  },
  computed: {
    ...mapState("partnersCenter", ["invitesSent"])
  },
  mounted() {
    this.dispatch();
  },
  watch: {
    dialog(v) {
      if (!v) this.itemToEdit = null;
    }
  },
  methods: {
    edit(item) {
      this.itemToEdit = item;
      this.dialog = true;
    },
    profile(item) {
      return item.is_admin ? "Administrador" : get(item, "perfil.name");
    },
    statusBadge(item) {
      if (item.accepted_at) return "active-badge";
      if (item.rejected_at) return "inactive-badge";
      return "draft-badge";
    },
    dispatch(offset) {
      this.loading = true;
      this.$store
        .dispatch("partnersCenter/getInvites", { offset })
        .then(
          ({ count, next, previous }) =>
            (this.pagination = { count, next, previous })
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
